import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-columns",
  "use": "icon-th-columns-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-columns\">\n<path d=\"M13 4H8C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6V26C6 26.5304 6.21071 27.0391 6.58579 27.4142C6.96086 27.7893 7.46957 28 8 28H13C13.5304 28 14.0391 27.7893 14.4142 27.4142C14.7893 27.0391 15 26.5304 15 26V6C15 5.46957 14.7893 4.96086 14.4142 4.58579C14.0391 4.21071 13.5304 4 13 4ZM13 26H8V6H13V26ZM24 4H19C18.4696 4 17.9609 4.21071 17.5858 4.58579C17.2107 4.96086 17 5.46957 17 6V26C17 26.5304 17.2107 27.0391 17.5858 27.4142C17.9609 27.7893 18.4696 28 19 28H24C24.5304 28 25.0391 27.7893 25.4142 27.4142C25.7893 27.0391 26 26.5304 26 26V6C26 5.46957 25.7893 4.96086 25.4142 4.58579C25.0391 4.21071 24.5304 4 24 4ZM24 26H19V6H24V26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-columns.svg
// module id = Y1BZ
// module chunks = 84